export default __webpack_public_path__ + "static/media/Enigma.242c3e44.png";